import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=120fe493"
import script from "./PaymentHeader.vue?vue&type=script&lang=js"
export * from "./PaymentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports